/**
 * 组件tabs:
 * 参数说明
 *    col字段名，用于传参
 *    valueType值类型： [ columns: 字段，corr_method: 计算方法]
 *    viewType视图类型： [ grid: 表格， select: 下拉选择、]
 *    label显示标签
 *    values选中值，根据视图定义值类型，string,array,number,date...
 *    toolTip 描述信息
 */
export const componentList = {
  shurushuchu: [
    {
      name: '输入',
      isResource: true,
      enabled: true,
      component: true,
      description: '',
      resourceId: '',
      tabs: [
        {
          tabName: '数据源设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'resource',
              viewType: 'select',
              label: '数据源',
              values: ''
            },
            {
              name: 'data',
              viewType: 'grid',
              label: '数据',
              values: [],
              viewRefresh: true,
              toolTip: '可以重新获取数据源'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'input_output_data',
          label: '',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    }
  ],
  yuchuli: [
    {
      name: '分组聚合',
      methodNum: '013',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'multipleSelect',
              limit: 1,
              viewRefresh: true,
              label: '分组列名',
              values: [],
              toolTip: '此处只允许选择一列'
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'aggregation_columns',
              valueType: 'group_method',
              viewType: 'dict',
              viewRefresh: true,
              label: '聚合字典',
              values: [],
              toolTip: '聚合方法不能为空'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '记录去重',
      methodNum: '014',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: []
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'drop_out_dict',
          "outIndex": "0",
          label: '被删除的重复数据',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": "1",
          label: '去重结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '缺失值处理',
      methodNum: '015',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'method',
              valueType: 'nan_method',
              viewType: 'select',
              label: '缺失处理方法',
              values: []
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'diff_dict',
          "outIndex": "0",
          label: '差异数据',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": "1",
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '数据标准化',
      methodNum: '016',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'method',
              valueType: 'standar_method',
              viewType: 'select',
              label: '标准化方法',
              values: []
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '数据集划分',
      methodNum: '017',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '输入源',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'test_size',
              viewType: 'inputNumber',
              min: 0.0001,
              max: 0.9999,
              step: 0.1,
              precision: 4,
              label: '测试集大小',
              values: 0,
              toolTip: '取0-1之间的小数'
            },
            {
              name: 'random_state',
              viewType: 'inputNumber',
              label: '随机种子',
              values: 0
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'train_data',
          "outIndex": "0",
          label: '训练数据集',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'test_data',
          "outIndex": "1",
          label: '测试数据集',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '数学函数',
      methodNum: '018',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'multipleSelect',
              limit: 1,
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: '此处只允许选择一列'
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'method',
              valueType: 'math_method',
              viewType: 'select',
              label: '数学函数方法',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '运行结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '新增序列',
      methodNum: '019',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'ind',
              viewType: 'input',
              label: '新增列名',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '异常值处理',
      methodNum: '020',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: []
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'upper_quantile',
              viewType: 'inputNumber',
              min: 0,
              max: 1,
              step: 0.1,
              precision: 4,
              label: '上四分位',
              values: "0",
              toolTip: '取0-1之间的小数'
            },
            {
              name: 'lower_quantile',
              viewType: 'inputNumber',
              min: 0,
              max: 1,
              step: 0.1,
              precision: 4,
              label: '下四分位',
              values: "0",
              toolTip: '取0-1之间的小数'
            },
            {
              name: 'enlarge_factor',
              viewType: 'inputNumber',
              min: 0,
              step: 1,
              precision: 4,
              label: '扩大倍数',
              values: 0,
              toolTip: '超出扩大区间视为异常值'
            },
            {
              name: 'method',
              valueType: 'error_method',
              viewType: 'select',
              label: '异常值处理方法',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'data_sum_dict',
          "outIndex": "0",
          label: '异常值的数量',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'diff_dict',
          "outIndex": "1",
          label: '差异数据',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '2',
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '排序',
      methodNum: '021',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'sort_by',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '排序列名',
              values: []
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'ascending',
              valueType: 'sort_method',
              viewType: 'select',
              label: '排序方式',
              values: null
            },
            {
              name: 'na_position',
              valueType: 'na_position',
              viewType: 'select',
              label: '缺失值位置',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '编码',
      methodNum: '035',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '需要编码的列',
              values: []
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'encoding_method',
              valueType: 'encoding_method',
              viewType: 'select',
              label: '编码方式',
              values: null
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    }
  ],
  tongjifengxi: [
    {
      name: '相关性分析',
      methodNum: '001',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: '请选择两列或者两列以上'
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'corr_method',
              valueType: 'corr_method',
              viewType: 'select',
              label: '相关性系数计算方法',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          label: '',
          "outIndex": "0",
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '卡方分析',
      methodNum: '002',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          description: '卡方分析结果',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '纯随机性检验',
      methodNum: '003',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'multipleSelect',
              limit: 1,
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: '此处只允许选择一列'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          description: '纯随机性检验结果',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '单样本T检验',
      methodNum: '004',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'multipleSelect',
              limit: 1,
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: '此处只允许选择一列'
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'popmean',
              viewType: 'inputNumber',
              precision: 4,
              label: '总体均值',
              values: null
            }
          ]
        }
      ]
    },
    {
      name: '双样本T检测',
      methodNum: '005',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'multipleSelect',
              limit: 2,
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: '此处只允许选择两列'
            }
          ]
        }
      ]
    },
    {
      name: '全表统计',
      methodNum: '006',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: []
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'nan_count_dict',
          "outIndex": "1",
          label: '缺失值情况表',
          description: '',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": "2",
          label: '统计结果',
          description: '',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '因子分析',
      methodNum: '007',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: []
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'n_components',
              viewType: 'inputNumber',
              label: '潜在空间的维度',
              values: 0
            },
            {
              name: 'max_iter',
              viewType: 'inputNumber',
              label: '最大迭代次数',
              values: 0
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          description: '',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '正态性检验',
      methodNum: '008',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: []
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'axis',
              valueType: 'axis',
              viewType: 'select',
              label: '轴',
              values: ''
              // toolTip:'计算方法'
            },
            {
              name: 'nan_policy',
              valueType: 'nan_policy',
              viewType: 'select',
              label: 'nan处理方式',
              values: ''
              // toolTip:'计算方法'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          description: '',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '主成分分析',
      methodNum: '009',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '列名',
              values: []
            }
          ]
        },
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'n_components',
              valueType: 'axis',
              viewType: 'inputNumber',
              label: '空间维度',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          description: '',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '频数统计',
      methodNum: '010',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: '此处只允许选择一列'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '',
          columns: '[]',
          description: '',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '平稳性检验',
      methodNum: '011',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'multipleSelect',
              limit: 1,
              viewRefresh: true,
              label: '列名',
              values: [],
              toolTip: '此处只允许选择一列'
            }
          ]
        }
      ]
    },
    {
      name: '方差分析',
      methodNum: '012',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'depend_var_name',
              valueType: 'column',
              viewType: 'multipleSelect',
              limit: 1,
              viewRefresh: true,
              label: '因变量列名',
              values: [],
              toolTip: '此处只允许选择一列'
            },
            {
              name: 'col_names',
              valueType: 'column',
              viewType: 'grid',
              viewRefresh: true,
              label: '自变量列名',
              values: []
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: 'apriori关联规则',
      methodNum: '034',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      // 参数配置
      tabs: [
        {
          tabName: '字段设置',
          elements: [
            {
              name: 'backets_col',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '购物篮ID列名',
              values: ''
            },
            {
              name: 'goods_col',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '商品名称列名',
              values: ''
            },
            {
              name: 'min_support',
              viewType: 'inputNumber',
              step: 0.1,
              precision: 4,
              label: '最小支持度',
              values: null
            },
            {
              name: 'min_confidence',
              viewType: 'inputNumber',
              step: 0.1,
              precision: 4,
              label: '最小置信度',
              values: null
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    }
  ],
  fenlei: [
    {
      name: 'CART分类树',
      methodNum: '028',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }, {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'criterion',
              valueType: 'criterion_class_method',
              viewType: 'select',
              label: '决策树划分的准则',
              values: ''
            },
            {
              name: 'splitter',
              valueType: 'splitter_method',
              viewType: 'select',
              label: '决策树分裂策略',
              values: ''
            },
            {
              name: 'max_depth',
              viewType: 'inputNumber',
              canNull: true,
              nullValue: false,
              label: '决策树的最大深度',
              values: null
            },
            {
              name: 'max_leaf_nodes',
              viewType: 'inputNumber',
              canNull: true,
              nullValue: false,
              label: '最大叶节点数量',
              values: null
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'feature_dict',
          "outIndex": "0",
          label: '模型特征的重要性信息',
          cat: 'DATA'
        },
        {
          id: 'res_table_dict',
          "outIndex": "1",
          label: '模型评价指标表',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": "4",
          label: '结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": "5",
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: '支持向量分类',
      methodNum: '029',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'gamma',
              valueType: 'gamma_method',
              viewType: 'select',
              label: '核函数系数',
              values: ''
            },
            {
              name: 'kernel',
              valueType: 'kernel_method',
              viewType: 'select',
              label: '核函数',
              values: ''
            },
            {
              name: 'degree',
              viewType: 'inputNumber',
              label: '多项式poly函数的维度',
              values: null
            },
            {
              name: 'max_iter',
              viewType: 'inputNumber',
              label: '最大迭代次数',
              values: null
            },
            {
              name: 'C',
              viewType: 'inputNumber',
              precision: 4,
              label: '惩罚系数',
              values: null
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'res_table_dict',
          "outIndex": "0",
          label: '模型评价指标表',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: '逻辑回归分类',
      methodNum: '030',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'multi_class',
              valueType: 'multi_class_method',
              viewType: 'select',
              label: '分类方式',
              values: ''
            },
            {
              name: 'penalty',
              valueType: 'penalty_method',
              viewType: 'select',
              label: '惩罚项（正则化类型）',
              values: ''
            },
            {
              name: 'solver',
              dependenceKey: 'penalty',
              valueType: 'solver_method',
              viewType: 'select_cascade',
              label: '优化方式',
              values: '',
              toolTip: '优化方式依赖惩罚项，请先选择惩罚项'
            },
            {
              name: 'C',
              viewType: 'inputNumber',
              step: 0.1,
              precision: 4,
              label: '正则化强度的倒数',
              values: 1
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'res_table_dict',
          "outIndex": "0",
          label: '模型评价指标表',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: '最近邻分类',
      methodNum: '031',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'n_neighbors',
              viewType: 'inputNumber',
              label: '距离最近点数',
              values: null
            },
            {
              name: 'algorithm',
              valueType: 'algorithm_method',
              viewType: 'select',
              label: '寻找k近邻点的算法',
              values: ''
            },
            {
              name: 'leaf_size',
              viewType: 'inputNumber',
              label: '叶子节点大小',
              values: null
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'res_table_dict',
          "outIndex": "0",
          label: '模型评价指标表',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '结果',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: '朴素贝叶斯分类',
      methodNum: '032',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'method',
              valueType: 'naive_bayes_method',
              viewType: 'select',
              label: '方法',
              values: ''
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'res_table_dict',
          "outIndex": "0",
          label: '模型评价指标表',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: 'RFM模型',
      methodNum: '033',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'name',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '用户名列名',
              values: ''
            },
            {
              name: 'paydate',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '付款日期列名',
              values: ''
            },
            {
              name: 'amount',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '金额列名',
              values: ''
            },
            {
              name: 'r_bins',
              viewType: 'multipleInputNumber',
              multiple: 6,
              label: 'R打分区间',
              values: [],
              toolTip: '必须全部填写，前五段为区间段，对应分值1-5分'
            },
            {
              name: 'f_bins',
              viewType: 'multipleInputNumber',
              multiple: 6,
              label: 'F打分区间',
              values: [],
              toolTip: '必须全部填写，前五段为区间段，对应分值1-5分'
            },
            {
              name: 'm_bins',
              viewType: 'multipleInputNumber',
              multiple: 6,
              label: 'M打分区间',
              values: [],
              toolTip: '必须全部填写，前五段为区间段，对应分值1-5分'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'summary_result_dict',
          "outIndex": "0",
          label: '模型结果概要',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": "1",
          label: '模型结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    }
  ],
  huigui: [
    {
      name: '线性回归',
      methodNum: '025',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'fit_intercept',
              valueType: 'fit_intercept_method',
              viewType: 'radio',
              label: '是否计算截距',
              values: null
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'md_info_dict',
          "outIndex": "1",
          label: '重要指标',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: 'CART回归树',
      methodNum: '026',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'criterion',
              valueType: 'criterion_method',
              viewType: 'select',
              label: '决策树划分的准则',
              values: ''
            },
            {
              name: 'splitter',
              valueType: 'splitter_method',
              viewType: 'select',
              label: '决策树分裂策略',
              values: ''
            },
            {
              name: 'max_depth',
              viewType: 'inputNumber',
              canNull: true,
              nullValue: false,
              label: '决策树的最大深度',
              values: null
            },
            {
              name: 'max_leaf_nodes',
              viewType: 'inputNumber',
              canNull: true,
              nullValue: false,
              label: '最大叶节点数量',
              values: null
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'md_info_dict',
          "outIndex": "0",
          label: '重要指标',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: '支持向量回归',
      methodNum: '027',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'label',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '标签',
              values: ''
            },
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'gamma',
              valueType: 'gamma_method',
              viewType: 'select',
              label: '核函数系数',
              values: ''
            },
            {
              name: 'kernel',
              valueType: 'kernel_method',
              viewType: 'select',
              label: '核函数',
              values: ''
            },
            {
              name: 'degree',
              viewType: 'inputNumber',
              label: '多项式poly函数的维度',
              values: null
            },
            {
              name: 'max_iter',
              viewType: 'inputNumber',
              label: '最大迭代次数',
              values: null
            },
            {
              name: 'C',
              viewType: 'inputNumber',
              precision: 4,
              label: '惩罚系数',
              values: null
            },
            {
              name: 'coef0',
              viewType: 'inputNumber',
              precision: 4,
              label: '核函数的常数项',
              values: null
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'md_info_dict',
          "outIndex": "1",
          label: '重要指标',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    }
  ],
  julei: [
    {
      name: 'K-means聚类',
      methodNum: '022',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'n_clusters',
              viewType: 'inputNumber',
              label: '聚类数',
              values: 0
            },
            {
              name: 'max_iter',
              viewType: 'inputNumber',
              label: '最大迭代次数',
              values: 0
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增列名',
              values: '',
              toolTip: '新增列为分类列'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'cluster_centers_dict',
          "outIndex": "0",
          label: '聚类中心',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '聚合结果',
          cat: 'DATA'
        },
        {
          id: 'model_name',
          "outIndex": '4',
          label: '模型文件',
          cat: 'MODEL'
        },
      ]
    },
    {
      name: 'DBSCAN聚类',
      methodNum: '023',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'min_samples',
              viewType: 'inputNumber',
              label: '最小样本数',
              values: 0
            },
            {
              name: 'eps',
              viewType: 'inputNumber',
              label: '领域大小',
              values: 0
            },
            {
              name: 'leaf_size',
              viewType: 'inputNumber',
              label: '叶子大小',
              values: 0
            },
            {
              name: 'algorithm',
              valueType: 'algorithm_method',
              viewType: 'select',
              label: '聚类算法',
              values: ''
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增列名',
              values: '',
              toolTip: '新增列为分类列'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": '2',
          label: '聚合结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: '凝聚层次聚类',
      methodNum: '024',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: []
            },
            {
              name: 'n_clusters',
              viewType: 'inputNumber',
              label: '集群数',
              values: 0
            },
            {
              name: 'affinity',
              valueType: 'affinity_method',
              viewType: 'select',
              label: '度量',
              values: ''
            },
            {
              name: 'linkage',
              valueType: 'linkage_method',
              viewType: 'select',
              label: '链接标准',
              values: ''
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增列名',
              values: '',
              toolTip: '新增列为分类列'
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": '2',
          label: '聚合结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    }
  ],
  shixu: [
    {
      name: '差分',
      methodNum: '036',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'col_name',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '列名',
              values: []
            },
            {
              name: 'periods',
              viewType: 'inputNumber',
              label: '移动的幅度',
              values: null
            },
            {
              name: 'add_name',
              viewType: 'input',
              label: '差分后列名',
              values: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '处理结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: 'Arima时序预测',
      methodNum: '037',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'timeseries',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '时间序列列名',
              values: ''
            },
            {
              name: 'time_col',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '时间列列名',
              values: ''
            },
            {
              name: 'p',
              viewType: 'inputNumber',
              label: '自回归阶数',
              values: null
            },
            {
              name: 'd',
              viewType: 'inputNumber',
              label: '差分阶数',
              values: null
            },
            {
              name: 'q',
              viewType: 'inputNumber',
              label: '移动平均阶数',
              values: null
            },
            {
              name: 'periods',
              viewType: 'inputNumber',
              label: '预测长度',
              values: null
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": '3',
          label: '预测结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    },
    {
      name: 'GM(1,1)时序预测',
      methodNum: '038',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '',
          value: '',
          cat: 'DATA'
        }
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'timeseries',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '时间序列列名',
              values: ''
            },
            {
              name: 'time_col',
              valueType: 'column',
              viewType: 'select',
              viewRefresh: true,
              label: '时间列列名',
              values: ''
            },
            {
              name: 'periods',
              viewType: 'inputNumber',
              label: '预测长度',
              values: null
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "1",
          label: '重要指标',
          columns: '[]',
          cat: 'DATA'
        },
        {
          id: 'output_data_dict2',
          "outIndex": '4',
          label: '预测结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    }
  ],
  yingyong: [
    {
      name: '模型应用',
      methodNum: '039',
      enabled: true,
      component: true,
      description: '',
      inputs: [
        {
          label: '模型文件',
          value: '',
          cat: 'MODEL'
        },
        {
          label: '输入源',
          value: '',
          cat: 'DATA'
        },
      ],
      tabs: [
        {
          tabName: '参数配置',
          elements: [
            {
              name: 'features',
              valueType: 'column',
              viewType: 'multipleSelect',
              viewRefresh: true,
              label: '特征列表',
              values: [],
              toolTip: '要求与训练数据格式相同'
            },
            {
              name: 'add_col',
              viewType: 'input',
              label: '新增预测列名',
              values: '',
              toolTip: ''
            }
          ]
        }
      ],
      outputs: [
        {
          id: 'output_data_dict',
          "outIndex": "0",
          label: '结果',
          columns: '[]',
          cat: 'DATA'
        }
      ]
    }
  ]
}
